import type { HttpInterceptorFn } from '@angular/common/http';

export const platformInterceptor: HttpInterceptorFn = (req, next) => {
  const clonedRequest = req.clone({
    setHeaders: { 'X-Platform': 'web' },
  });

  return next(clonedRequest);
};
